import localhost from "apis/localhost";
import { showErrorModal } from "slices/app/actions/error";

import { setIsLoading, setProposal } from "./proposalSlice";

export const fetchProposal = (proposalId) => async (dispatch) => {
  dispatch(setIsLoading(true));

  try {
    const { status, data } = await localhost.get(`/nextgen/proposal/${proposalId}`);
    if (status === 204) {
      return { notFound: true };
    }
    if (data) {
      dispatch(setProposal(data));
    }
    return data;
  } catch (error) {
    dispatch(showErrorModal(error));
    return false;
  } finally {
    dispatch(setIsLoading(false));
  }
};
